import type { ClientLocation } from "../../types/experiment";
import type { Location } from "../../types/experiment";
import { LocationEditor } from "../Shared/LocationEditor";
import { Button } from "../ui/button";
import { X, Plus } from "lucide-react";

interface ClientLocationFilterProps {
  value: ClientLocation;
  onChange: (value: ClientLocation) => void;
}

const defaultLocation: Location = { is_eu: false };

export function ClientLocationFilter({ value, onChange }: ClientLocationFilterProps) {
  const addLocation = () =>
    onChange({ ...value, locations: [...value.locations, defaultLocation] });
  const updateLocation = (i: number, loc: Location) => {
    const next = [...value.locations];
    next[i] = loc;
    onChange({ ...value, locations: next });
  };
  const removeLocation = (i: number) =>
    onChange({ ...value, locations: value.locations.filter((_, j) => j !== i) });

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-xs text-overlay1">Locations</span>
        <Button type="button" variant="outline" size="sm" onClick={addLocation}>
          <Plus className="h-3 w-3 mr-1" />
          Add
        </Button>
      </div>
      {value.locations.map((loc, i) => (
        <div key={i} className="flex items-start gap-2">
          <div className="flex-1">
            <LocationEditor
              label={`Location ${i + 1}`}
              value={loc}
              onChange={(l) => updateLocation(i, l)}
            />
          </div>
          <Button type="button" variant="ghost" size="icon" onClick={() => removeLocation(i)} className="mt-6">
            <X className="h-4 w-4 text-red" />
          </Button>
        </div>
      ))}
    </div>
  );
}
